export const FEATURE_NAME = 'team';

export const EMAIL = 'email';
export const FIRST_NAME = 'firstname';
export const LAST_NAME = 'lastname';
export const STATUS = 'status';
export const IS_ADMIN = 'isAdmin';
